import { createStyles, makeStyles } from '@material-ui/core';

const styles = () =>
    createStyles({
        root: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
        },
        inline: {
            display: 'inline-flex',
        },
        viewport: {
            height: '100vh',
        },
    });

export default makeStyles(styles, { name: 'MuiCenter' });
